export default __webpack_public_path__ + "assets/mp3/a78ecf18761c57eff1ba3bf785aae4c1.mp3";